/**
 * @generated SignedSource<<e0ede957c62f2a43bb216941075886fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type JobType = "freelance" | "permanent";
export type RateMode = "day" | "hour" | "month" | "week" | "year";
import { FragmentRefs } from "relay-runtime";
export type RateEditDialog_User$data = {
  readonly profile: {
    readonly freelancerRate: {
      readonly currency: {
        readonly code: string | null | undefined;
      };
      readonly value: number;
    } | null | undefined;
    readonly jobTypes: ReadonlyArray<JobType>;
    readonly rateMode: RateMode | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "RateEditDialog_User";
};
export type RateEditDialog_User$key = {
  readonly " $data"?: RateEditDialog_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"RateEditDialog_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RateEditDialog_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Money",
          "kind": "LinkedField",
          "name": "freelancerRate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Currency",
              "kind": "LinkedField",
              "name": "currency",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobTypes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rateMode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7002a03542202ebe6200ab62c4732d2e";

export default node;
